var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2773_3832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39565 1.72656H28.5857C34.7347 1.72656 36.272 3.26384 36.272 9.39565V20.3293C36.272 26.4784 34.7347 27.9984 28.6029 27.9984H9.39565C3.26384 28.0157 1.72656 26.4784 1.72656 20.3466V9.39565C1.72656 3.26384 3.26384 1.72656 9.39565 1.72656Z",
    stroke: "#0044EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 28.0156V36.272",
    stroke: "#0044EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72656 20.7266H36.272",
    stroke: "#0044EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 36.2734H26.772",
    stroke: "#0044EB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5012 8.09979L15.9595 14.6163C15.7046 15.0853 15.9058 15.6581 16.4088 15.8957C16.5568 15.9656 16.7144 15.9987 16.8696 15.9987C17.2421 15.9987 17.6013 15.8079 17.7812 15.4767L21.3229 8.96019C21.5778 8.49125 21.3766 7.91847 20.8736 7.68091C20.3707 7.44329 19.7561 7.63079 19.5012 8.09979Z",
    fill: "#0044EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0186 9.94958C22.4174 9.57784 23.064 9.57784 23.4627 9.94958L25.7035 12.0385C26.1023 12.4103 26.1023 13.013 25.7035 13.3847L23.4627 15.4736C23.2633 15.6595 23.002 15.7524 22.7407 15.7524C22.4793 15.7524 22.218 15.6595 22.0186 15.4736C21.6199 15.1019 21.6199 14.4991 22.0186 14.1274L23.5374 12.7116L22.0186 11.2958C21.6199 10.924 21.6199 10.3213 22.0186 9.94958Z",
    fill: "#0044EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8011 10.3728L15.3199 11.7887C15.7187 12.1604 15.7187 12.7631 15.3199 13.1348C15.1205 13.3207 14.8592 13.4136 14.5979 13.4136C14.3365 13.4136 14.0752 13.3207 13.8758 13.1348L11.635 11.0459C11.2362 10.6742 11.2362 10.0715 11.635 9.69977L13.8758 7.61084C14.2746 7.2391 14.9212 7.2391 15.3199 7.61084C15.7187 7.98258 15.7187 8.58529 15.3199 8.95698L13.8011 10.3728Z",
    fill: "#0044EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2773_3832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMonitor);
export default __webpack_public_path__ + "static/media/icon_monitor.6bc92a7451d4e565bd36f42603c9a067.svg";
export { ForwardRef as ReactComponent };